import { ButtonLink, PlusIcon } from '@fukuri-admins/ui/common';
import emptyLeftImage from '../../../../assets/images/empty_left.png';
import emptyRightImage from '../../../../assets/images/empty_right.png';
import styles from './styles.module.scss';

type Props = {
  createLink: string;
};

export const GroupEmpty: React.FC<Props> = ({ createLink }) => {
  return (
    <div className={styles.container}>
      <div className={styles.box}>
        <div>
          <img src={emptyLeftImage} alt='' className={styles.image} />
          <img src={emptyRightImage} alt='' className={styles.image} />
        </div>
        <p className={styles.description}>
          グループを設定することで、
          <br />
          特定の企業向けにバナーやプッシュ通知を
          <br />
          配信することができます。
        </p>
      </div>
      <p className={styles.emptyText}>グループはまだありません</p>
      <ButtonLink
        to={createLink}
        icon={<PlusIcon size='xs' />}
        iconPosition='left'
        variant='primary'
        size='md'
      >
        新規作成
      </ButtonLink>
    </div>
  );
};
